import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { BigPicklistInput, BodyTextMedium } from 'Packages/FacetDesign/Components';

export default buildFacetDesignOverride()
  .nameOverride('description', {
    _component: () => BodyTextMedium,
  }, overrideReadOnly)
  .nameOverride('whyDidYouJoin', {
    _component: () => BigPicklistInput,
  }, overrideReadOnly)
  .nameOverride('other', {
    _customProps: {
      rows: 2,
    },
  });
